import { ResolveFn } from '@angular/router';
import { IndustryService } from '../commonServices/industry.service';
import { inject } from '@angular/core';

export const industriesResolver: ResolveFn<any> = (route, state) => {
  return inject(IndustryService).get();
};
